import { useState, useEffect, useCallback, useRef } from 'react';

const SMS_CD = 60; // 秒

/**
 * 短信验证码倒计时 hook
 * @param {string} key - 缓存key，区分不同场景（如 register / reset）
 */
export default function useSmsCountdown(key) {
  const cacheKey = `sms_cd_${key}`;
  const timerRef = useRef(null);

  const getRemain = useCallback(() => {
    const saved = localStorage.getItem(cacheKey);
    if (!saved) return 0;
    const diff = Math.floor((Number(saved) - Date.now()) / 1000);
    return diff > 0 ? diff : 0;
  }, [cacheKey]);

  const [countdown, setCountdown] = useState(getRemain);

  useEffect(() => {
    if (countdown <= 0) {
      clearInterval(timerRef.current);
      return;
    }
    timerRef.current = setInterval(() => {
      const remain = getRemain();
      setCountdown(remain);
      if (remain <= 0) clearInterval(timerRef.current);
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [countdown, getRemain]);

  const start = useCallback(() => {
    const expireAt = Date.now() + SMS_CD * 1000;
    localStorage.setItem(cacheKey, String(expireAt));
    setCountdown(SMS_CD);
  }, [cacheKey]);

  return { countdown, start, isCounting: countdown > 0 };
}
